const config = {
    production_api_url: 'https://lms.profy21.ru',
}
export default config;